import { store } from '@/store';

const localMovePageChildrenToProject = (pages, projectToId, projectFromId) => {
  let children = [];
  const pageTree = store.getters.getProjectPagesTree(projectFromId);
  for (let i = 0; i < pages.length; i += 1) {
    const page = pageTree[pages[i]];
    if (page?.children) {
      children = localMovePageChildrenToProject(page.children, projectToId, projectFromId);
    }
    children.push(page);
    store.dispatch('localAddPageInProjectPageTree', {
      projectId: projectToId,
      page,
    });
    store.dispatch('addPageToTeamProject', {
      projectId: projectToId,
      page: {
        id: page.id,
        title: page.title,
        ...(page.icon && { icon: page.icon }),
      },
    });
    store.dispatch('removePageFromTeamProject', {
      pageId: page.id,
      projectId: projectFromId,
    });
    store.dispatch('localUpdatePageProp', {
      pageId: page.id,
      propertyName: 'project_id',
      value: projectToId,
    });
  }
  return children;
};

const localUpdatePagePropForAllChildren = ({ pages, projectId, prop, value }) => {
  let children = [];
  if (!pages) return children;
  const pageTree = store.getters.getProjectPagesTree(projectId);
  for (let i = 0; i < pages.length; i += 1) {
    const page = pageTree[pages[i]];
    if (page?.children) {
      children = localUpdatePagePropForAllChildren({
        pages: page.children || [],
        projectId,
        prop,
        value,
      });
    }
    children.push(page);
    store.dispatch('localUpdatePageProp', {
      pageId: page.id,
      propertyName: prop,
      value,
    });
  }
  return children;
};

const movePageChildrenToArchiveTree = (pages, projectId) => {
  let children = [];
  const timeNow = Math.floor(Date.now() / 1000);
  const pageTree = store.getters.getProjectPagesTree(projectId);
  for (let i = 0; i < pages.length; i += 1) {
    const page = pageTree[pages[i]];
    if (page?.children) {
      children = movePageChildrenToArchiveTree(page.children, projectId);
    }
    children.push(page);
    store
      .dispatch('localAddPageInArchivePageTree', {
        projectId,
        page,
        // eslint-disable-next-line no-loop-func
      })
      .then(() => {
        store.dispatch('localRemovePagesFromTree', {
          projectId,
          pages: [page],
        });
      });
    store.dispatch('localUpdatePageProp', {
      pageId: page.id,
      propertyName: 'archived',
      value: {
        time_archived: timeNow,
        user_id: store.getters.getUserId,
        parent_page_id: page.parent,
      },
    });
  }
  return children;
};

export {
  localMovePageChildrenToProject,
  localUpdatePagePropForAllChildren,
  movePageChildrenToArchiveTree,
};
